"use client";

import { Button } from "@watt/ui/components/ui/button";
import { Calendar } from "@watt/ui/components/ui/calendar";
import {
  Popover,
  PopoverContent,
  PopoverTrigger
} from "@watt/ui/components/ui/popover";
import { cn } from "@watt/ui/utils/classname-tailwind-merge";
import { format } from "date-fns";
import { Calendar as CalendarIcon } from "lucide-react";

interface DatePickerProps extends React.ComponentProps<typeof PopoverContent> {
  date?: Date;
  setDate: (date?: Date) => void;
}

export const DatePicker: React.FC<DatePickerProps> = ({
  ref,
  date,
  setDate,
  ...props
}) => (
  <Popover {...props}>
    <PopoverTrigger asChild>
      <Button
        className={cn(
          "w-full justify-start text-left font-normal",
          !date && "text-muted-foreground"
        )}
        variant={"outline"}
      >
        <CalendarIcon className="mr-2 h-4 w-4" />
        {date ? format(date, "PPP") : <span>Pick a date</span>}
      </Button>
    </PopoverTrigger>
    <PopoverContent className="w-auto p-0" ref={ref}>
      <Calendar initialFocus mode="single" onSelect={setDate} selected={date} />
    </PopoverContent>
  </Popover>
);
